import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="px-4 py-20 md:py-28" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3">
          {/* Who This Is For */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="bg-midnight-800 border border-midnight-700/60 rounded-lg p-6 border-l-4 border-l-rescue-green" data-id="element-4">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-6" data-id="element-5">
              Who This Is For
            </h3>
            <ul className="space-y-4" role="list" data-id="element-6">
              <li className="flex items-start gap-3" data-id="element-7">
                <CheckIcon className="w-5 h-5 text-rescue-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-8" />
                <span className="font-body text-gray-300" data-id="element-9">
                  W-2 employees who are tired of being upcharged for basic
                  filings.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-10">
                <CheckIcon className="w-5 h-5 text-rescue-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-11" />
                <span className="font-body text-gray-300" data-id="element-12">
                  DoorDash, Uber, and Freelance workers with "side hustle"
                  income.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-13">
                <CheckIcon className="w-5 h-5 text-rescue-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-14" />
                <span className="font-body text-gray-300" data-id="element-15">
                  Students and low-to-mid income filers (&lt;$79k) who need
                  every penny of their refund.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-16">
                <CheckIcon className="w-5 h-5 text-rescue-green flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-17" />
                <span className="font-body text-gray-300" data-id="element-18">
                  Anyone staring at a tax software paywall at 11:00 PM on April
                  14th.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Who This Is NOT For */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: 'easeOut'
        }} className="bg-midnight-800 border border-midnight-700/60 rounded-lg p-6 border-l-4 border-l-rescue-red" data-id="element-19">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-6" data-id="element-20">
              Who This Is <span className="text-rescue-red" data-id="element-21">NOT</span> For
            </h3>
            <ul className="space-y-4" role="list" data-id="element-22">
              <li className="flex items-start gap-3" data-id="element-23">
                <XIcon className="w-5 h-5 text-rescue-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-24" />
                <span className="font-body text-gray-300" data-id="element-25">
                  Multi-state corporations or high-net-worth individuals with
                  complex offshore accounts.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-26">
                <XIcon className="w-5 h-5 text-rescue-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-27" />
                <span className="font-body text-gray-300" data-id="element-28">
                  Professional day traders with thousands of crypto
                  transactions.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-29">
                <XIcon className="w-5 h-5 text-rescue-red flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-30" />
                <span className="font-body text-gray-300" data-id="element-31">
                  People who enjoy paying $150 to a software company for "fun."
                </span>
              </li>
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}